import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paper, Grid, Typography, Tooltip } from "@mui/material";

import {
  MdVerified,
  MdDoorSliding,
  MdOutlineVerified,
  MdOutlineDoorSliding,
  MdOutlineKeyboardAlt,
} from "react-icons/md";
import { IoIosNotifications, IoMdNotificationsOutline } from "react-icons/io";
import KeyboardAltRoundedIcon from "@mui/icons-material/KeyboardAltRounded";

import { styled } from "@mui/material/styles";
import pages from "../../../constants/pages";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Styled Components
const TabButton = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  font-size: 7.5px;
  font-family: "Open Sans, sans-serif";
  font-weight: 400;
  align-items: center;
`;

const OuterBox = styled(Box)`
  box-sizing: border-box;
  min-height: 10vh;
`;

const BoxPaper = styled(Paper)`
  width: 50vw;
  margin: 0 auto;
  background: white;
  display: flex;
  box-shadow: rgb(251, 248, 242) 0px 0px 0px 1px;
  border: 1px solid rgb(84, 82, 238);
  padding: 1.5px;
  @media (max-width: 900px) {
    width: 90%;
  }
`;

const TabItem = ({
  title,
  route,
  selectedRoute,
  navigate,
  IconActive,
  IconInactive,
}) => {
  const isSelected = selectedRoute === route;

  const handleClick = () => {
    if (!isSelected) navigate(route);
  };

  return (
    <Grid
      item
      container
      justifyContent={"center"}
      xs={4}
      onClick={handleClick}
      sx={{
        transition: "0.25s ease-out",
        borderRadius: "7.5px",
        background: isSelected ? "rgb(84, 82, 238)" : "white",
      }}
    >
      <Tooltip title={title}>
        <TabButton>
          {isSelected ? (
            <IconActive style={{ fontSize: "20px", color: "white" }} />
          ) : (
            <IconInactive
              style={{ fontSize: "20px", color: "rgb(84, 82, 238)" }}
            />
          )}
          <Typography
            variant="body1"
            sx={{
              color: isSelected ? "white" : "rgb(84, 82, 238)",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            {title}
          </Typography>
        </TabButton>
      </Tooltip>
    </Grid>
  );
};

export default function DashboardFooter() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRoute, setSelectedRoute] = useState(location.pathname);

  useEffect(() => {
    setSelectedRoute(location.pathname);
  }, [location]);

  function stopCamera() {
    const stream = document.querySelector("video")?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      document.querySelector("video").srcObject = null;
    }
  }

  const handleNavigation = (route) => {
    if (selectedRoute !== route) {
      stopCamera();
      navigate(route);
    }
  };

  return (
    <OuterBox>
      <BoxPaper>
        <TabItem
          title="Auto"
          route={pages.MainGateEntryWithBackCamera.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdDoorSliding}
          IconInactive={MdOutlineDoorSliding}
        />
        <TabItem
          title="Manual"
          route={pages.ManualEntry.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={KeyboardAltRoundedIcon}
          IconInactive={MdOutlineKeyboardAlt}
        />
        <TabItem
          title="Resend"
          route={pages.ResendNotification.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={IoIosNotifications}
          IconInactive={IoMdNotificationsOutline}
        />
        <TabItem
          title="Verify"
          route={pages.ManualVerification.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        />

        {/* <TabItem
          title="Booking"
          route={pages.AddBooking.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        /> */}

        <TabItem
          title="Booking Stats"
          route={pages.BookingStats.route}
          selectedRoute={selectedRoute}
          navigate={(route) => {
            handleNavigation(route);
          }}
          IconActive={MdVerified}
          IconInactive={MdOutlineVerified}
        />
      </BoxPaper>
    </OuterBox>
  );
}
